module.exports = __webpack_public_path__ + "static/media/map5.0a84f2f9.gif";